/** 
 * Formats a given number, either as a number or string, based on the following (seen in PWA-535 and CM-1753):
 * 
 * Set all number displays to have a minimum of 2 significant figures and that if the number is 100 or above that no decimals would be shown. 
 * Examples:
 * 0.007364 would display as 0.0074,
 * 99.9 would display as 99.9,
 * 102.738 would display as 103, (Only truncates the value, so actually returns 102)
 * 103748 would display as 103748
 * Still handling negative numbers
*/
export function formatNumber(value: any): string {
    let floatValue;
    
    if (typeof value === "number") {
        floatValue = value;
    } else {
        floatValue = parseFloat(value);
    }

    if (isNaN(floatValue)) return '';

    let wholeNum = Math.trunc(floatValue);
    let wholeNumString = wholeNum.toString();
    let isNegativeString = "";
    if (floatValue < 0) {
        isNegativeString = "-";
    }

    if (Math.abs(wholeNum) < 100 && floatValue.toString().includes('.')) {
        const decimalValue = floatValue.toString().replace(wholeNumString + '.', "0.");
        let roundedDecimal;
        let finalValue;

        if (Math.abs(wholeNum) > 9) {
            roundedDecimal = parseFloat(decimalValue).toPrecision(1);
            if (roundedDecimal === "1") {
                wholeNum++;
                wholeNumString = wholeNum.toString() + ".0";
                finalValue = wholeNumString;
            }
            else if (roundedDecimal.includes("e")) {
                finalValue = wholeNumString + ".0";
            } else {
                finalValue = wholeNumString + "." + roundedDecimal.toString().charAt(2);
            }
        }
        else if (Math.abs(wholeNum) > 0) {
            roundedDecimal = parseFloat(decimalValue).toPrecision(2);
            if (roundedDecimal === "1.0") {
                wholeNum++;
                wholeNumString = wholeNum.toString() + ".00";
                finalValue = wholeNumString;
            }
            else if (roundedDecimal.includes("e")) {
                finalValue = wholeNumString + ".00";
            } else {
                finalValue = wholeNumString + "." + roundedDecimal.toString().charAt(2) + roundedDecimal.toString().charAt(3);
            }
        }
        else {
            roundedDecimal = parseFloat(decimalValue).toPrecision(2);
            finalValue = roundedDecimal.toString();
        }

        return isNegativeString + finalValue;

    }

    return wholeNumString;
}